module.exports = __webpack_public_path__ + "img/classes_icon.ba59915f.svg";